import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {OnInit} from "@angular/core";
import {AuthService} from "../../../../service/autenticacao/auth.service";
import {FaleComRhFormFactory} from "../../../../service/fale-com-rh/fale-com-rh-form-factory.service";
import {MascaraUtil} from "../../../../helper/MascaraUtil";
import {CustomValidators} from "../../../../validators/CustomValidators";
import { buildSolicitacaoDocumentoPayload } from "../partials/solicitacao-documento/solicitacao-documento.config";

export abstract class FaleComRhBaseComponent implements OnInit {
  form: FormGroup;
  assuntoSelecionado = '';
  identificadorSelecionado = 'servidor';
  opcoesDeAssunto = [];
  opcoesIdentificacao = [];
  arquivosSalvosRepresentanteLegal: any[] = [];
  protected preencherDadosComDadosDaSesaoAutomaticamente = true;

  constructor(
    protected authService: AuthService,
    protected formFactory: FaleComRhFormFactory
  ) {
    this.form = this.formFactory.criarFormularioBase(this.authService.usuarioDTO);
  }

  ngOnInit() {
    this.atualizarOpcoesIdentificacao();
    this.atualizarOpcoesAssunto();



    this.monitorarMudancas();
  }

  atualizarOpcoesAssunto() {
    const tipoSolicitanteControl = this.form.get('tipoSolicitante');
    const tipoSolicitante = tipoSolicitanteControl ? tipoSolicitanteControl.value : '';

    let labelObito = 'Comunicar o óbito de magistrados e servidores';

    if (tipoSolicitante === 'servidor') {
      labelObito = 'Comunicar o óbito de Servidor(a)';
    } else if (tipoSolicitante === 'magistrado') {
      labelObito = 'Comunicar o óbito de Magistrado(a)';
    }

    this.opcoesDeAssunto = [
      {val: 'cadastral', label: 'Alteração de dados cadastrais'},
      {val: 'conta', label: 'Alteração de conta bancária'},
      {val: 'obito', label: labelObito},
      {val: 'solicitacaoDocumentos', label: 'Solicitação de documentos'}
    ];
  }

  atualizarOpcoesIdentificacao() {
    this.opcoesIdentificacao = [
      {val: 'servidor', label: 'Servidor(a)'},
      {val: 'magistrado', label: 'Magistrado(a)'}
    ];
  }

  monitorarMudancas() {
    this.form.get('tipoSolicitante').valueChanges.subscribe(val => {
      this.identificadorSelecionado = val;
      this.atualizarOpcoesAssunto();
    });

    this.form.get('tipoAssunto').valueChanges.subscribe(val => {
      this.assuntoSelecionado = val;
      this.resetarGrupos();

      if (val === 'cadastral') {
        this.form.addControl('dadosCadastrais', this.formFactory.criarGrupoDadosCadastrais());
        if(this.preencherDadosComDadosDaSesaoAutomaticamente){
          this.setarDadosCadastrais();
        }
      }

      if (val === 'conta') {
        this.form.addControl('contaBancaria', this.formFactory.criarGrupoContaBancaria());
      }

      if (val === 'obito') {
        this.form.addControl('obito', this.formFactory.criarGrupoObito());
      }

      if (val === 'solicitacaoDocumentos') {
        this.form.addControl('solicitacaoDocumento', this.formFactory.criarGrupoSolicitacaoDocumento());
      }
    });

    this.procedimentoFeitoPorTerceiroControl.valueChanges.subscribe(valor => {
      this.atualizarEstadoRepresentanteLegal(!!valor);
    });

    this.atualizarEstadoRepresentanteLegal(this.deveExibirUploadRepresentanteLegal);
  }

  resetarGrupos() {
    ['dadosCadastrais', 'contaBancaria', 'obito', 'solicitacaoDocumento'].forEach(g => {
      if (this.form.contains(g)) this.form.removeControl(g);
    });
  }

  get dadosCadastraisGroup(): FormGroup {
    return this.form.get('dadosCadastrais') as FormGroup;
  }

  get contaBancariaGroup(): FormGroup {
    return this.form.get('contaBancaria') as FormGroup;
  }

  get obitoGroup(): FormGroup {
    return this.form.get('obito') as FormGroup;
  }

  get solicitacaoDocumentoGroup(): FormGroup {
    return this.form.get('solicitacaoDocumento') as FormGroup;
  }

  getFormControl(form: string): FormControl {
    return this.form.get(form) as FormControl;
  }

  get procedimentoFeitoPorTerceiroControl(): FormControl {
    return this.form.get('procedimentoFeitoPorTerceiro') as FormControl;
  }

  get arquivoRepresentanteLegalControl(): FormArray {
    return this.form.get('arquivoRepresentanteLegal') as FormArray;
  }

  get nomeRepresentanteLegalControl(): FormControl {
    return this.form.get('nomeRepresentanteLegal') as FormControl;
  }

  get cpfRepresentanteLegalControl(): FormControl {
    return this.form.get('cpfRepresentanteLegal') as FormControl;
  }

  get deveExibirUploadRepresentanteLegal(): boolean {
    return !!this.procedimentoFeitoPorTerceiroControl.value;
  }

  onArquivosRepresentanteLegalChange(arquivos: any[]) {
    this.arquivoRepresentanteLegalControl.clear();

    if (arquivos && arquivos.length) {
      arquivos.forEach(arq => {
        this.arquivoRepresentanteLegalControl.push(new FormGroup({
          nomeArquivo: new FormControl(arq.nomeArquivo),
          conteudo: new FormControl(arq.conteudo)
        }));
      });
    }

    this.arquivoRepresentanteLegalControl.markAsTouched();
    this.arquivoRepresentanteLegalControl.updateValueAndValidity();
    this.form.updateValueAndValidity({ emitEvent: false });
  }

  private atualizarEstadoRepresentanteLegal(ativo: boolean) {
    if (ativo) {
      this.nomeRepresentanteLegalControl.setValidators([Validators.required]);
      this.cpfRepresentanteLegalControl.setValidators([Validators.required, CustomValidators.cpf]);
      this.arquivoRepresentanteLegalControl.setValidators([Validators.required]);
    } else {
      this.nomeRepresentanteLegalControl.reset('', { emitEvent: false });
      this.cpfRepresentanteLegalControl.reset('', { emitEvent: false });
      this.nomeRepresentanteLegalControl.clearValidators();
      this.cpfRepresentanteLegalControl.clearValidators();
      this.resetarArquivosRepresentanteLegal();
      this.arquivoRepresentanteLegalControl.clearValidators();
    }

    this.nomeRepresentanteLegalControl.updateValueAndValidity({ emitEvent: false });
    this.cpfRepresentanteLegalControl.updateValueAndValidity({ emitEvent: false });
    this.arquivoRepresentanteLegalControl.updateValueAndValidity({ emitEvent: false });
    this.form.updateValueAndValidity({ emitEvent: false });
  }

  setarDadosCadastrais() {
    let usuario = this.authService.usuarioDTO;
    let grupo = this.dadosCadastraisGroup;

    if (!grupo) {
      return;
    }

    grupo.patchValue({
      nomeCompleto: usuario.nome,
      cpf: MascaraUtil.formatarCpf(usuario.cpfcnpj),
      emailPessoal: usuario.email,
      cep: MascaraUtil.formatarCep(usuario.cep),
      logradouro: usuario.logradouro,
      numero: usuario.numero,
      complemento: usuario.complemento,
      bairro: usuario.bairro,
      pais: usuario.pais,
      uf: usuario.uf,
      municipio: usuario.municipio,
      telefoneFixo: MascaraUtil.formatarTelefoneFixo(usuario.telefoneResid),
      telefoneCelular: MascaraUtil.formatarTelefoneCelular(usuario.telefoneCel),
      matricula: ''
    });
  }

  getMensagem(raw) {
    if (raw.dadosCadastrais && raw.dadosCadastrais.justificativa) {
      return raw.dadosCadastrais.justificativa;
    } else if (raw.obito && raw.obito.observacoes) {
      return raw.obito.observacoes;
    }
  }

  // ============================
  // MAPEAMENTOS
  // ============================
  mapTipoSolicitante(valor: string): number {
    let map = {
      servidor: 1,
      magistrado: 2,
      representante: 3
    };
    return map[valor] || 0;
  }

  mapTipoAssunto(valor: string): number {
    let map = {
      cadastral: 1,
      conta: 2,
      obito: 3,
      solicitacaoDocumentos: 4
    };
    return map[valor] || 0;
  }

  getGrupoNome(tipo: number): string {
    if (tipo === 1) return 'dadosCadastrais';
    if (tipo === 2) return 'contaBancaria';
    if (tipo === 3) return 'obito';
    if (tipo === 4) return 'solicitacaoDocumento';
    return '';
  }

  mapearDadosPorAssunto(tipo: number, raw: any) {
    if(tipo === 1){
      let dados = raw.dadosCadastrais;
      return {
        dadosCadastrais: {
          nomeCompleto: dados.nomeCompleto,
          matricula: dados.matricula,
          cpf: dados.cpf,
          telefoneFixo: dados.telefoneFixo,
          telefoneCelular: dados.telefoneCelular,
          emailPessoal: dados.emailPessoal,
          cep: dados.cep,
          logradouro: dados.logradouro,
          numero: dados.numero,
          complemento: dados.complemento,
          bairro: dados.bairro,
          municipio: dados.municipio,
          uf: dados.uf,
          pais: dados.pais,
          justificativa: dados.justificativa
        }
      };
    }else  if (tipo === 2) {
      let conta = raw.contaBancaria;
      return {
        contaBancaria: {
          titular: conta.titular,
          cpf: conta.cpf,
          bancoCodigo: conta.banco,
          bancoNome: 'Itaú Unibanco S.A.',
          agencia: conta.agencia,
          conta: conta.conta,
          digito: conta.digito,
          tipoConta: conta.tipoConta
        }
      };
    }else if (tipo === 3) {
      let obito = raw.obito;
      return {
        obito: {
          nomeFalecido:    obito.nomeFalecido,
          matriculaFalecido: obito.matriculaFalecido,
          cpfInformante:             obito.cpfInformante,
          telefoneFixoInformante:    obito.telefoneFixoInformante,
          telefoneCelularInformante: obito.telefoneCelularInformante,
          emailInformante: obito.emailInformante,
          dataFalecimento: obito.dataFalecimento,
          observacoes:     obito.observacoes
        }
      };
    } else {
      return {
        solicitacaoDocumento: buildSolicitacaoDocumentoPayload(raw.solicitacaoDocumento)
      };
    }
  }

  mapearAnexos(grupoNome: string) {
    if (!grupoNome) {
      return [];
    }

    let arquivos = this.form.get(grupoNome + '.arquivo') as FormArray;

    if (!arquivos || !arquivos.length) {
      return [];
    }

    return arquivos.controls.map(function (ctrl) {
      return {
        nomeArquivo: ctrl.value.nomeArquivo,
        conteudo: ctrl.value.conteudo
      };
    });
  }

  mapearAnexosRepresentanteLegal() {
    if (!this.arquivoRepresentanteLegalControl || !this.arquivoRepresentanteLegalControl.length) {
      return [];
    }

    return this.arquivoRepresentanteLegalControl.controls.map(function (ctrl) {
      return {
        nomeArquivo: ctrl.value.nomeArquivo,
        conteudo: ctrl.value.conteudo
      };
    });
  }

  resetarArquivosRepresentanteLegal() {
    this.arquivoRepresentanteLegalControl.clear();
    this.arquivoRepresentanteLegalControl.markAsPristine();
    this.arquivoRepresentanteLegalControl.markAsUntouched();
    this.arquivoRepresentanteLegalControl.updateValueAndValidity({ emitEvent: false });
    this.arquivosSalvosRepresentanteLegal = [];
  }
}
